import axios from "axios";
import { API_ENDPOINTS } from '../../apiConfig';
import { RoleModulePermission } from '../admin/roles/RoleApi';
//const API_BASE =  `${PLATFORM_API_URL}/user-role-mappings`;
//const API_BASE_URL = "http://localhost:7860/api";

 

export interface UserDTO {
  id: string;              // Unique ID of the user
  tenantId: string;        // Multi-tenant support
  tenantName: string;
  username: string;
  email: string;
  fullName?: string;
  role: string;            // e.g., "ADMIN", "MANAGER", "USER"
  permissions: RoleModulePermission[]; // List of module-level permissions
  isActive: boolean;
  createdAt?: string;      // optional
  updatedAt?: string;      // optional
}

// Login user with tenant name
export const loginUser = (identifier: string, password: string, tenantName: string) => {
  return axios.post(`${API_ENDPOINTS.auth}/auth/login`, {
    emailOrMobile: identifier,
    password,
    tenantName
  });
};

// Search tenants by name (minimum 3 characters should be sent by caller)
export const searchTenantNames = (keyword: string) => {
  return axios.get(`${API_ENDPOINTS.platform}/tenants/name-search`, {
    params: { keyword }
  });
};

